import React from "react";
import { useFormContext } from "react-hook-form";
import { FieldErrorMessage } from "../ui/Text";
import { Validation } from "@/types/form";

interface TextAreaInputProps {
  readonly rows?: number;
  readonly columns?: number;
  label: string;
  field: string;
  defaultValue?: string;
  placeholder: string;
  disabled?: boolean;
  validation: Validation;
}

const TextAreaInput: React.FC<TextAreaInputProps> = ({ label, rows = 2, columns = 10, validation, placeholder, field, disabled, defaultValue }) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();
  const errorMessage: any = errors[field]?.message;

  const getRegisterOptions = () => {
    const registerOptions: any = {};
    const maxLength = validation?.maxLength || 50;
    // If field is disabled
    if (disabled) {
      return {};
    }

    registerOptions.maxLength = {
      value: maxLength,
      message: `The maximum character allowed is ${maxLength}.`,
    };

    if (validation?.required) {
      registerOptions.required = "This field is required.";
    }
    if (validation?.minLength) {
      registerOptions.minLength = {
        value: validation.minLength,
        message: `The minimum character allowed is ${validation.minLength}.`,
      };
    }
    return registerOptions;
  };
  return (
    <div className="mt-1 relative">
      <textarea
        id={label + "_text"}
        rows={rows}
        cols={columns}
        className={`w-full px-3 py-7 text-text-default resize-none text-13 rounded-lg outline-none border border-fieldBorder hover:border-gray-400 focus:border-text-primary-500  ${
          errors[field]?.message ? "border-text-error" : null
        } ${disabled ? "cursor-not-allowed" : "cursor-text"}`}
        placeholder={placeholder}
        {...register(field, {
          ...getRegisterOptions(),
        })}
        defaultValue={defaultValue}
        // adding +1 to show error
        maxLength={(validation?.maxLength || 50) + 1}
        disabled={disabled}
      />
      {errorMessage && <FieldErrorMessage text={errorMessage} />}
    </div>
  );
};

export default TextAreaInput;
